import { hexToRgb } from './hex-to-rgb';

export function createLinearGradient(color: string, ctx: CanvasRenderingContext2D): CanvasGradient {
  const gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);
  gradientStroke.addColorStop(1, `rgba(${hexToRgb(color)},1)`);
  gradientStroke.addColorStop(0.3, `rgba(${hexToRgb(color)},0.6)`);
  return gradientStroke;
}
